<template>
    <div class="com-header1 my-header flex">
        <div class="h-left">

        </div>
        <div class="h-center flex1">
            {{ title }}
        </div>
        <div class="h-right">
            <!-- &nbsp;&nbsp;{{ nowWeek }} -->
            {{ nowDate }}&nbsp;&nbsp;{{ nowTime }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
            timer: null
        }
    },
    data() {
        return {
			nowDate: "", // 当前日期
			nowTime: "", // 当前时间
			nowWeek: "", // 当前星期
        }
    },
    mounted() {
        // 时间
        this.getDate()
        if(this.timer) {
            clearInterval(this.timer)
        }
        this.timer = setInterval(() =>{
            this.getDate()
        }, 30 * 1000)
    },
    methods: {
        // 时间
		getDate: function() {
		    let _this = this
			let yy = new Date().getFullYear()
			let mm = new Date().getMonth() + 1
			let dd = new Date().getDate()
			let week = new Date().getDay()
			let hh = `${(new Date().getHours() < 10 ? '0' : '') + new Date().getHours()}`
			let mf = `${(new Date().getMinutes() < 10 ? "0" : '') + new Date().getMinutes()}`
			if (week == 1) {
				this.nowWeek = "星期一";
			} else if (week == 2) {
				this.nowWeek = "星期二";
			} else if (week == 3) {
				this.nowWeek = "星期三";
			} else if (week == 4) {
				this.nowWeek = "星期四";
			} else if (week == 5) {
				this.nowWeek = "星期五";
			} else if (week == 6) {
				this.nowWeek = "星期六";
			} else {
				this.nowWeek = "星期日";
			}
            // `${hh > 12 ? '下午' : '上午'}` + 
			_this.nowTime = hh + ":" + mf;
			// _this.nowDate = yy + "年" + mm + "月" + dd + "日";
			_this.nowDate = yy + "-" + mm + "-" + dd;
		},
    },
	destroyed() {
		clearInterval(this.timer)
	}
}
</script>

<style lang="scss" scoped>
@import './comm.scss';
.my-header {
    > div {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-bottom: 36px;
        box-sizing: border-box;
        font-size: $FontSize30;
    }
    .h-left, .h-right {
        width: 500px;
    }
    .h-right {
        font-size: $FontSize36;
        @include ffamily-DS;
    }
    .h-center {
        // width: 950px;
        font-size: $FontSize60;
        font-weight: bold;
    }
}
</style>